import HeaderWidget from "../../../../common/components/molecule/HeaderWidget/HeaderWidget";
import { useMicroNavigator } from "../../../../common/components/organisme/MicroNavigator/MicroNavigatorContext";
import CreateUpdateNewLinkFormPresenter from "../../../../features/planBT/components/Link/CreateUpdateNewLinkForm/CreateUpdateNewLinkFormPresenter";

export default function EditLinkPage() {
  const { navigate } = useMicroNavigator();
  return (
    <div style={{color: "white"}}>
      <HeaderWidget handleBackBtn={() => navigate("list")} variant={"dark"}>
        Modifier une liaison
      </HeaderWidget>
      <CreateUpdateNewLinkFormPresenter isUpdate />
    </div>
  );
}
